<template>
  <!-- 武夷山周边旅游汽车指南 -->
  <div>
    <div class="comInfo">
      <!-- 中间 -->
      <div class="rowB">
        <div class="body">
          <div class="topTitle">{{info.title ? info.title : info.name}}</div>
          <div class="littleTitle">
            <span>发布日期：{{info.showTime}}</span>
            <span style="margin-left:5px">编辑者：admin</span>
            <span style="margin-left:5px">来源：{{info.source}}</span>
            <span style="margin-left:5px">阅读次数：{{info.hits}}</span>
          </div>
          <div class="line"></div>
          <div class="leftBody">
             <div v-html="info.details" class="leftBodyFont">
               <!-- {{ info.details }} -->
             </div>
          </div>
        </div>
      </div>

      <!-- 右边 -->
      <div class="rowC">
        <div class="layout">
          <div style="writing-mode:vertical-rl;display:flex;flex-direction:row">
            <div style="margin-top:1.018vh;">武夷山景区</div>
            <div style="margin-top:1.018vh;">天下难寻</div>
            <div style="margin-top:1.018vh;">Wuyi</div>
            <div>Mountain</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/css/details.css";
import { getMenuOpenList } from "@/api/publicApi";// 0,'about_info',1,1
import  {addHits}  from "@/util/publicHits";
// import { getTrafficBus, getTrafficBusHits } from "@/api/common";
export default {
  name: "trafficInfoC",
  data() {
    return {
     info:{}
    };
  },

  mounted(){
    this.getInfoFunction()
  },
  methods: {
    //获取
    async getInfoFunction(type) {
      const { code, data } = await getMenuOpenList(0,'traffic_bus',1,1);
      if (code == 200) {
        if (data.records.length > 0) {
          this.info = data.records[0]
          this.getHitsFunction(this.info.id)
        }
      }
    },
    //点击
    getHitsFunction(id) {
      addHits(id);
    },
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/traffic/trafficInfoC.vue